import type { Params } from "../../engine/types";

export interface Preset {
  /** Stable forever — preset ids live inside shared URLs. */
  id: string;
  name: string;
  /** Diff from DEFAULTS (see engine/params.ts). */
  params: Partial<Params>;
  /** Curated seed so the named look is reproducible on first click. */
  seed?: string;
}

// NOTE: first-pass values for the plot model — tuned visually against the
// live engine; every param re-plots deterministically per seed.
export const PRESETS: Preset[] = [
  {
    id: "smoke",
    name: "Smoke",
    seed: "smoke01",
    params: {
      plumeCount: 1,
      spread: 0.09,
      halo: 0.2,
      particleCount: 1100,
      lifetime: 10,
      speed: 0.8,
      evolution: 0.5,
      dotOpacity: 0.12,
      dotSize: 1.4,
    },
  },
  {
    id: "nebula",
    name: "Nebula",
    seed: "nebul01",
    params: {
      palette: "aurora",
      plumeCount: 3,
      spread: 0.2,
      halo: 0.5,
      particleCount: 1800,
      octaves: 3,
      flowScale: 0.8,
      dotOpacity: 0.1,
      dotSize: 1.2,
      exposure: 1.15,
    },
  },
  {
    id: "ribbons",
    name: "Ribbons",
    seed: "ribbn01",
    params: {
      emission: "line",
      particleCount: 500,
      flowScale: 2.4,
      roughness: 0.35,
      speed: 1.7,
      lifetime: 8,
      dotSize: 1.3,
      stagger: 5,
    },
  },
  {
    id: "ember",
    name: "Ember",
    seed: "ember01",
    params: {
      palette: "ember",
      plumeCount: 1,
      spread: 0.07,
      halo: 0.2,
      particleCount: 900,
      windAngle: 270,
      windStrength: 0.3,
      vortex: 0.35,
      lifetime: 9,
      dotOpacity: 0.15,
    },
  },
  {
    id: "ice",
    name: "Ice",
    seed: "glace01",
    params: {
      palette: "ice",
      plumeCount: 2,
      spread: 0.16,
      halo: 0.15,
      particleCount: 500,
      flowScale: 0.6,
      speed: 0.55,
      evolution: 0.15,
      lifetime: 12,
      dotSize: 2,
    },
  },
];

export function presetById(id: string): Preset | undefined {
  return PRESETS.find((p) => p.id === id);
}
